import { Injectable } from '@angular/core';

@Injectable()
export class ModalService {
  public showModal: boolean = false;
  public showChildModal: boolean = false;
  public saveChildren: boolean = false;

  close;

  toggleModal(): void {
    this.showModal = !this.showModal;
  }

  toggleChildModal(): void {
    this.showChildModal = !this.showChildModal;
  }
}
